import { NotificationPreviewComponent } from './notification-preview/notification-preview.component';
import { NotificationEditComponent } from './notification-edit/notification-edit.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth/auth.guard';
import { NotificationsComponent } from 'app/notifications/notifications.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'notifications',
        canActivate: [AuthGuard],
        children: [
          { path: '', component: NotificationsComponent },
          { path: 'create', component: NotificationEditComponent },
          { path: 'preview', component: NotificationPreviewComponent },
          {
            path: ':id',
            children: [
              {
                path: 'edit',
                component: NotificationEditComponent
              }
            ]
          },
        ]
      },
    ])
  ],
  exports: [RouterModule]
})
export class NotificationRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/notifications.routing.module.ts